import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import { gsap } from 'gsap';
import { breakpoint } from '../../../vendorjs/breakpoint-helper.vendor';
export var teaserParagraphBehavior = function teaserParagraphBehavior() {
  Alpine.data('teaserParagraphBehavior', function () {
    var animateIcons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return {
      $teaserParagraph: false,
      svgIcons: [],
      svgData: [],
      debug: false,
      init: function init() {
        this.$teaserParagraph = this.$el;

        if (animateIcons) {
          this.svgIcons = this.$el.querySelectorAll('svg.animated-svg');
          this.lastTeaserElementAlter();
          this.svgAnimationsInit();
          this.animateSvgs();
        }
      },
      sortSvgPaths: function sortSvgPaths(a, b) {
        return +a.getAttribute('data-order') - +b.getAttribute('data-order');
      },
      svgScrollTrigger: function svgScrollTrigger(index) {
        var svgElement = this.svgData[index].svgElement;
        var startElementPosition = 'top';
        var startTriggerPosition = 'bottom';
        var endElementPosition = breakpoint.isTouch ? 'bottom+=48' : 'bottom-=48';
        var endTriggerPosition = 'bottom';
        var svgStart = svgElement.getAttribute('data-start') || "".concat(startElementPosition, " ").concat(startTriggerPosition);
        var svgEnd = svgElement.getAttribute('data-end') || "".concat(endElementPosition, " ").concat(endTriggerPosition);
        return {
          trigger: svgElement,
          scrub: 3,
          start: svgStart,
          end: svgEnd,
          markers: this.debug,
          preventOverlaps: false
        };
      },
      lastTeaserElementAlter: function lastTeaserElementAlter() {
        var nextElementSibling = this.$teaserParagraph.nextElementSibling;
        var teaserClass = 'm-teaser-paragraph';
        var teaserLastClass = 'm-teaser-paragraph--last'; // All teasers.

        if (this.$teaserParagraph.classList.contains(teaserClass)) {
          if (nextElementSibling) {
            var classList = nextElementSibling.classList;

            if (!classList.contains(teaserClass)) {
              this.$teaserParagraph.classList.add(teaserLastClass);
            }
          } else {
            this.$teaserParagraph.classList.add(teaserLastClass);
          }
        }
      },
      svgAnimationsInit: function svgAnimationsInit() {
        var _this = this;

        var svgIcons = this.svgIcons;
        svgIcons.forEach(function (svg) {
          var svgPaths = Array.from(svg.querySelectorAll('path')).sort(_this.sortSvgPaths);

          _this.svgData.push({
            svgElement: svg,
            svgPaths: svgPaths
          });
        }, this);
      },
      animateSvgs: function animateSvgs() {
        var _this2 = this;

        if (this.svgData.length > 0) {
          var svgData = this.svgData;
          svgData.forEach(function (svg, index) {
            var svgPaths = svg.svgPaths;

            var scrollTrigger = _this2.svgScrollTrigger(index);

            var svgTimeline = gsap.timeline({
              id: "svg-".concat(index),
              ease: 'sine.linear',
              paused: true,
              seek: 0,
              scrollTrigger: scrollTrigger
            });
            svgPaths.forEach(function (svgPath) {
              var svgLabel = svgPath.getAttribute('data-label') || '';
              var svgDraw = svgPath.getAttribute('data-draw') || '0';
              var svgDuration = svgPath.getAttribute('data-duration') || '0.5';
              var svgPosition = svgPath.getAttribute('data-position') || '>-0.2';
              var svgReversed = svgPath.getAttribute('data-reversed') || false;
              var svgEase = svgPath.getAttribute('data-ease') || 'sine.linear';

              if (svgLabel) {
                svgTimeline.addLabel(svgLabel, svgPosition);
              } // Fade in animation.


              svgTimeline.from(svgPath, {
                duration: 0.25,
                reversed: svgReversed,
                opacity: 0,
                ease: svgEase
              }, svgPosition); // Stroke animation.

              svgTimeline.from(svgPath, {
                drawSVG: svgDraw,
                duration: svgDuration,
                reversed: svgReversed,
                ease: svgEase
              }, svgPosition);
              svgData.svgTimeline = svgTimeline;
            }, _this2);
          }, this); // Set SVG data.

          this.svgData = svgData;
        }
      }
    };
  });
};